import React from 'react';
import { Box, Button } from '@material-ui/core';
import { DonationProvider } from '@joindeed/calculate-fees';

import { ModalTitle, ModalTypography } from 'components/Modal/Modal';
import { ModalStep } from 'components/Flow/components/ModalStep';
import { StepComponentProps } from 'components/Flow/RenderMachine';
import wait from 'assets/onboarding/wait.svg';
import Img from 'retired/Img';

const getCopyMessage = ({
  isCAF,
  isChapter,
  isParentClaimed,
}: {
  isCAF: boolean;
  isChapter: boolean;
  isParentClaimed: boolean;
}) => {
  if (isCAF) {
    return 'Our nonprofit team is reviewing your request, please wait until you are approved.';
  }
  if (isChapter && isParentClaimed) {
    return 'We have sent a notification to your parent nonprofit, please wait until you are approved by the parent admin';
  }

  return 'You will receive an email in 2-3 business days when our nonprofit success team has finished reviewing your uploaded information.';
};

export const WaitForApproval = ({
  state,
  noWelcome,
}: StepComponentProps & { noWelcome: boolean }) => {
  const { donationProvider, isChapter, isParentClaimed } = state.context.nonprofit;

  const copy = getCopyMessage({
    isCAF: donationProvider === DonationProvider.CAF,
    isChapter,
    isParentClaimed,
  });

  return (
    <ModalStep
      showProgressBar
      actions={
        <div>
          <Button type="button" variant="contained" disabled>
            Next
          </Button>
        </div>
      }
      header={<Img src={wait} />}
      headerStyles={{
        paddingTop: 16,
        paddingBottom: 16,
      }}
    >
      <Box mb={4}>
        {!noWelcome && (
          <>
            <ModalTitle size="large">Welcome to Deed!</ModalTitle>
            <ModalTypography>
              Your home for corporate giving, volunteering, and relationship-building! Let&apos;s
              get you set up starting with user verification.
            </ModalTypography>
          </>
        )}
        <ModalTitle size={noWelcome ? 'large' : 'medium'}>Waiting for approval</ModalTitle>
        <ModalTypography>{copy}</ModalTypography>
      </Box>
    </ModalStep>
  );
};
